/**
 * Получает часть строки после совпадения
 * @param {string} text -  текст в котором выделяются совпадения.
 * @param {TMatches} matches - массив совпадений.
 * @param {number} index - индекс совпадения.
 */
export function getClosingForMatch(text, matches, index) {
  return index === matches.length - 1 ? text.substring(matches[index][1]) : text.substring(matches[index][1], matches[index + 1][0]);
}